export default __webpack_public_path__ + "static/media/flag_es_ES.40542097.png";